import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() { }

  Get(keyword: string) {
    let content = JSON.parse(localStorage.getItem(keyword));
    return content;
  }

  Set(keyword: string, value: object) {
    let content = JSON.stringify(value);
    localStorage.setItem(keyword, content);
  }

  Remove(keyword: string) {
    localStorage.removeItem(keyword);
  }

  Clear() {
    localStorage.clear();
  }

  Keys() {
    let content: string[] = [];
    for (let idx = 0; idx < localStorage.length; idx++) {
      const keyword = localStorage.key(idx);
      content.push(keyword);
    }
    return content;
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/local-storage.service.ts